<template>
  <div class="share-post-col">
    <div class="most-share-post">
      <div
        class="section-title"
        :class="[
          'section-title',
          darkClass && 'title' in darkClass ? darkClass.title : '',
        ]"
      >
        <h3 class="title">排行榜</h3>
      </div>
    </div>
    <div class="trending-sidebar-slider position-relative">
      <span
        @click="sharePostPrev"
        class="prev slick-arrow"
        style="display: block">
        <i class="fal fa-angle-left"></i>
      </span>
      <slider v-if="sharePosts.length > 0" :settings="trendingSidebarSlide" ref="sharePost">
        <div class="most-share-post-items">
          <template v-for="(data, index) in sharePosts.slice(0, 5)">
            <share-card
              :class="[darkClass && 'item' in darkClass ? darkClass.item : '']"
              :count="index + 1"
              :datas="data"
              :key="index"
            />
          </template>
        </div>
        <div class="most-share-post-items">
          <template v-for="(data, index) in sharePosts.slice(5, 10)">
            <share-card
              :class="[darkClass && 'item' in darkClass ? darkClass.item : '']"
              :count="index + 1"
              :datas="data"
              :key="index"
            />
          </template>
        </div>
      </slider>
      <span
        @click="sharePostNext"
        class="next slick-arrow"
        style="display: block">
        <i class="fal fa-angle-right"></i>
      </span>
    </div>
  </div>
</template>

<script>
import ShareCard from "../Utility/Cards/ShareCard.vue";
import Slider from "../Helpers/Slider.vue";
export default {
  components: { ShareCard, Slider },
  props: {
    darkClass: {
      type: Object,
    },
  },
  inject: ['dataWrapper', 'fetchStatus'],
  data: () => ({
    sharePosts: [],
    trendingSidebarSlide: {
      arrows: false,
      slidesToShow: 1,
      slideToScroll: 1,
    },
  }),
  watch: {
    'fetchStatus.isFetched': {
      handler(newVal) {
        if (newVal) {
          this.sharePosts = Array.isArray(this.dataWrapper.articles) 
            // 筛选 recommend 为 true 的数据
            ? this.dataWrapper.articles.filter(item => item.recommend === true)
              // 按 view 字段倒序排序
              .sort((a, b) => b.view - a.view)
              // 取前 10 条数据
              .slice(0, 10) 
            : [];
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    //share
    sharePostNext() {
      this.$refs.sharePost.next();
    },
    sharePostPrev() {
      this.$refs.sharePost.prev();
    },
  },
};
</script>

<style>
</style>